<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				<v-icon size="20" color="black" style="margin-right: 10px">{{ 'mdi-badge-account' }}</v-icon>
				{{ '디자이너 관리' }}
			</v-card-title>
			<v-data-table
				:style="'cursor: pointer;background-color:' + $theme.lightBlue"
				:headers="headers"
				:items="items"
				:search="search"
				@click:row="showItem"
				:items-per-page="100"
				:footerProps="{ 'items-per-page-options': [20, 100, 500, -1] }"
			>
				<template v-slot:top>
					<tr class="d-flex justify-space-between">
						<td style="width: 200px; margin-right: 20px">
							<v-text-field color="black" v-model="search" label="검색" class="mx-4" append-icon="mdi-magnify" style="width: 300px"></v-text-field>
						</td>
					</tr>
				</template>

				<template v-slot:item.userStatusType="props">
					<v-chip v-if="props.item.userStatusType" :color="getColorByUserStatus(props.item.userStatusType)" dark>
						{{ props.item.userStatusTypeName }}
					</v-chip>
					<v-chip v-if="!props.item.userStatusType && props.item.userStatusTypeName">
						{{ props.item.userStatusTypeName }}
					</v-chip>
				</template>

				<template v-slot:item.lastLoginAt="{ item }">
					{{ formatTimestamp(item.lastLoginAt) }}
				</template>

				<template v-slot:item.createAt="{ item }">
					{{ formatTimestamp(item.createAt) }}
				</template>

				<template v-slot:item.updateAt="{ item }">
					{{ formatTimestamp(item.updateAt) }}
				</template>

				<template v-slot:item.designerAuthStatusType="props">
					<v-chip :color="getColor(props.item.designerAuthStatusType)" dark>
						{{ props.item.designerAuthStatusTypeName }}
					</v-chip>
				</template>

				<template v-slot:item.designerIsWork="props">
					<v-chip :color="getColorByWork(props.item.designerIsWork)" dark>
						{{ props.item.designerIsWork ? '근무' : '휴무' }}
					</v-chip>
				</template>
			</v-data-table>
		</v-card>

		<DesignerEditDialog
			:show="editDialog"
			:item="selectedItem"
			icon="mdi-badge-account"
			title="디자이너 상세정보"
			okButtonText="저장"
			:okButton="true"
			cancelButtonText="닫기"
			:deleteButton="false"
			deleteButtonText="삭제"
			@onOk="modifyItem"
			@onCancel="
				selectedItem = $models.UserModel.create();
				editDialog = false;
			"
			@onDelete="deleteItemConfirm"
		>
		</DesignerEditDialog>

		<message-dialog
			:show="deleteMessageDialog"
			message="삭제하시겠습니까?"
			:okButton="true"
			cancelButtonText="취소"
			:deleteButton="true"
			deleteButtonText="삭제"
			@onOk="deleteItem"
			@onCancel="deleteMessageDialog = false"
		/>
	</div>
</template>

<script>
	import { formatTimestamp } from '@/js/util';
	import { userStatusTypeCode, designerAuthStatusTypeCode } from '@/js/types'; // 절대 경로 사용

	export default {
		name: 'DesignerList',
		props: {
			items: {
				default: [],
			},
		},
		data: () => ({
			headers,
			search: '',
			selectedItem: {},
			deleteMessageDialog: false,
			formValid: false,
			newItemDialog: false,
			editDialog: false,
		}),
		mounted: function() {},
		methods: {
			formatTimestamp,
			deleteItemConfirm() {
				this.deleteMessageDialog = true;
			},
			showItem(item) {
				this.selectedItem = this.$models.UserModel.set(item);
				this.selectedItem.id = item.id;
				this.editDialog = true;
			},
			// newItem() {
			// 	this.selectedItem = this.$models.UserModel.create();
			// 	this.newItemDialog = true;
			// },
			// async registItem(item) {
			// 	this.selectedItem = this.$models.UserModel.set(item);
			// 	this.$emit('registItem', this.selectedItem);
			// 	this.selectedItem = this.$models.UserModel.create();
			// 	this.newItemDialog = false;
			// },
			async modifyItem(item) {
				this.selectedItem = this.$models.UserModel.set(item);
				this.selectedItem.id = item.id;
				this.$emit('modifyItem', this.selectedItem);
				this.selectedItem = this.$models.UserModel.create();
				this.editDialog = false;
			},
			async deleteItem() {
				this.$emit('deleteItem', this.selectedItem.id);
				this.deleteMessageDialog = false;
				this.editDialog = false;
			},
			getColorByUserStatus(status) {
				return status == userStatusTypeCode.active.code ? this.$theme.primary : null;
			},
			getColorByWork(designerIsWork) {
				return designerIsWork ? this.$theme.primary : this.$theme.red;
			},
			getColor(status) {
				if (status == designerAuthStatusTypeCode.authComplete.code) {
					return this.$theme.primary;
				} else if (status == designerAuthStatusTypeCode.authReject.code) {
					return this.$theme.red;
				} else if (status == designerAuthStatusTypeCode.authWait.code) {
					return this.$theme.lightGrey;
				} else {
					return this.$theme.lightGrey;
				}
			},
		},
	};

	const headers = [
		{ text: '이름', align: 'start', sortable: true, value: 'name' },
		{ text: '닉네임', align: 'start', sortable: true, value: 'nickname' },
		{ text: '이메일', align: 'start', sortable: true, value: 'email' },
		{ text: '상태', align: 'start', sortable: true, value: 'userStatusType' },
		{ text: '근무지', align: 'start', sortable: true, value: 'storeName', width: '160px' },
		{ text: '근무상태', align: 'start', sortable: true, value: 'designerIsWork', width: '100px' },
		{ text: '인증상태', align: 'start', sortable: true, value: 'designerAuthStatusType', width: '100px' },
		{ text: '마지막 로그인', align: 'start', sortable: true, value: 'lastLoginAt', width: '180px' },
		{ text: '생성일', align: 'start', sortable: true, value: 'createAt', width: '180px' },
		// { text: '최종수정일', align: 'start', sortable: true, value: 'updateAt', width: '100px' },
	];
</script>

<style scoped></style>
